<template>
    <v-toolbar color="blue-grey darken-4" acolor="#2B3848" dark>
        <v-toolbar-title class="mr-4">
            <v-tooltip bottom v-if="!editing" color="black">
                <template v-slot:activator="{ on, attrs }">
                    <span v-on="on" v-bind="attrs" @click="startEditing()" class="editable">{{ model }}</span>
                </template>
                <span>{{ tooltip }}</span>
            </v-tooltip>
        </v-toolbar-title>

        <v-text-field
            v-if="editing"
            ref="editToolBarInput"
            flat
            solo-inverted
            hide-details
            v-model="editText"
            @keydown.enter="acceptEditedText()"
            @keydown.esc="cancelEditing()"
        />
        <v-btn v-if="editing" color="green" class="ml-4 mr-4" @click="acceptEditedText()">Guardar</v-btn>
        <v-btn v-if="editing" color="red" @click="cancelEditing()">Cancelar</v-btn>

    </v-toolbar>
</template>

<style lang="scss" scoped>
.editable {
    cursor: pointer;
    padding: 2px;
    border: 1px solid transparent;
    &:hover {
        border: 1px dotted white;
    }
}
</style>


<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class extends Vue {

    $refs!: {
        editToolBarInput: HTMLInputElement;
    };

    editing = false;
    editText = "";

    @Prop({ default: "Pulsa para cambiar el nombre" })
    tooltip?: string;

    @Prop({ required: true })
    model?: string;

    startEditing() {
        this.editText = this.model || "";
        this.editing = true;

        this.$nextTick(() => {
            this.$refs?.editToolBarInput?.focus();
        });
    }

    acceptEditedText() {
        if (this.editText !== this.model) {
            this.$emit("modelChanged", this.editText);
        }

        this.editing = false;
    }

    cancelEditing() {
        this.editing = false;
    }
}
</script>
